const typeWoningen = [
  "Portiekwoning of flat",
  "Rijtjeswoning",
  "Vrijstaande woning"
];

const houseTypes = [
  ["Detached house", '<span class="material-symbols-outlined">house</span>Detached house'],
  ["Porch house or apartment", '<span class="material-symbols-outlined">apartment</span> apartment'],
  ["Terraced house", '<span class="material-symbols-outlined">holiday_village</span>Terraced house']
];

const housesEnglishToDutch = {
  "Detached house": "Vrijstaande woning",
  "Porch house or apartment": "Portiekwoning of flat",
  "Terraced house": "Rijtjeswoning"
};

module.exports = {typeWoningen, houseTypes, housesEnglishToDutch};